import React from 'react';
import './style.scss'
import Partner1 from "../../images/partnters/1.png";
import Partner2 from "../../images/partnters/2.png";
import Partner3 from "../../images/partnters/3.png";
import Partner4 from "../../images/partnters/4.png";
import Partner5 from "../../images/partnters/5.png";
import Partner6 from "../../images/partnters/6.png";
import Partner7 from "../../images/partnters/7.png";
import Partner9 from "../../images/partnters/9.png";
import Partner10 from "../../images/partnters/10.png";
import Partner11 from "../../images/partnters/11.png";
import Partner12 from "../../images/partnters/12.svg";
import Partner13 from "../../images/partnters/13.png";
import Partner14 from "../../images/partnters/14.svg";
import Partner15 from "../../images/partnters/15.png";

function StrategicPartners() {
  return (
    <div className="strategic-partners" id="partners">
      <div className="container">
        <div className="title">Strategic Partners</div>
        <div className="partners-list">
          <div className="partner">
            <img src={Partner1} alt=""loading="lazy" />
          </div>
          <div className="partner">
            <img src={Partner2} alt="" className="archax" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner3} alt="" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner4} alt="" loading="lazy"/>
          </div>
          <div className="partner" style={{marginTop:'-17px'}}>
            <img src={Partner10} alt="" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner5} alt="" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner6} alt="" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner7} alt="" loading="lazy"/>
          </div>
          <div className="partner" >
            <img src={Partner12} width={85} alt="" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner9} alt="" loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner11} alt="" width={150} loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner15} alt="" width={100} loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner14} alt="" width={130} loading="lazy"/>
          </div>
          <div className="partner">
            <img src={Partner13} alt="" width={150} loading="lazy"/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StrategicPartners;
